module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "las-bottom-panel"
  }, [_c('div', [(!_vm.hideQuickAddAttributes) ? _c('quick-add-attributes', {
    attrs: {
      "viewOnly": _vm.viewOnly
    }
  }) : _vm._e(), _vm._v(" "), _c('target-definition', {
    class: [_vm.sizeClass],
    attrs: {
      "enableNot": _vm.lasActions,
      "enableMinus": _vm.xandrActions,
      "viewOnly": _vm.viewOnly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "las-bottom-panel__footer"
  }, [_c('bottom-pane-sizer', {
    staticClass: "las-bottom-panel__footer__sizer",
    attrs: {
      "current-size": _vm.currentBottomPaneSize
    },
    on: {
      "new-size": _vm.changeBottomPaneSize
    }
  }), _vm._v(" "), _c('definition-actions', {
    staticClass: "las-bottom-panel__footer__actions",
    class: {
      'viewOnly': _vm.viewOnly
    },
    attrs: {
      "enableSaving": _vm.enableSaving,
      "allowDownloadBtn": false,
      "viewOnly": _vm.viewOnly,
      "targetData": _vm.targetData,
      "lasActions": _vm.lasActions,
      "xandrActions": _vm.xandrActions
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a1c958"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/bottomPanel/BottomPanel.vue
// module id = 1823
// module chunks = 0